import m from 'mithril'
import { css } from '@emotion/css'
import { colors, font, space, card, btnPrimary, input, label } from '../styles/theme.js'
import { authModel } from '../models/auth.js'

const container = css`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
`

const formCard = css`
  ${card};
  width: 100%;
  max-width: 400px;
`

const title = css`
  font-size: ${font.size['2xl']};
  font-weight: ${font.weight.bold};
  margin-bottom: ${space.lg};
  text-align: center;
  color: ${colors.brand};
`

const fieldGroup = css`
  margin-bottom: ${space.md};
`

const errorMsg = css`
  color: ${colors.critical};
  font-size: ${font.size.sm};
  margin-bottom: ${space.md};
  text-align: center;
`

const successMsg = css`
  color: ${colors.teal};
  font-size: ${font.size.sm};
  margin-bottom: ${space.md};
  text-align: center;
`

const infoBanner = css`
  font-size: ${font.size.sm};
  color: ${colors.teal};
  background: ${colors.teal}10;
  border: 1px solid ${colors.teal}30;
  border-radius: 6px;
  padding: ${space.sm} ${space.md};
  margin-bottom: ${space.md};
  text-align: center;
`

const switchLink = css`
  text-align: center;
  margin-top: ${space.md};
  font-size: ${font.size.sm};
  color: ${colors.textSecondary};
  a { color: ${colors.brand}; cursor: pointer; }
`

export function LoginView() {
  let email = ''
  let password = ''
  let name = ''
  let inviteCode = ''
  let projectInviteCode = ''
  let isSignup = false
  let isForgotPassword = false
  let resetSent = false

  function submit(e) {
    e.preventDefault()
    authModel.clearError()
    if (isForgotPassword) {
      authModel.forgotPassword(email).then((ok) => {
        if (ok) { resetSent = true; m.redraw() }
      })
    } else if (isSignup) {
      authModel.signup(name, email, password, inviteCode || undefined, projectInviteCode || undefined)
    } else {
      authModel.login(email, password, projectInviteCode || undefined)
    }
  }

  return {
    oninit(vnode) {
      // Mithril hashbang routing puts query params in vnode.attrs, not window.location.search
      const code = vnode.attrs.invite
      if (code) {
        inviteCode = code
        isSignup = true
      }
      // Check for project invite code
      const projectCode = vnode.attrs.project_invite
      if (projectCode) {
        projectInviteCode = projectCode
        isSignup = true
      }
    },

    view() {
      const heading = isForgotPassword ? 'Reset password'
        : isSignup ? 'Create account'
        : 'Sign in'

      return m('div', { class: container }, [
        m('form', { class: formCard, onsubmit: submit }, [
          m('h1', { class: title }, heading),

          projectInviteCode
            ? m('div', { class: infoBanner }, 'Sign in or create an account to join the project.')
            : null,

          authModel.error
            ? m('div', { class: errorMsg }, authModel.error)
            : null,

          resetSent
            ? m('div', { class: successMsg }, 'If that email exists, a reset link has been sent. Check your email.')
            : null,

          isSignup && !isForgotPassword
            ? m('div', { class: fieldGroup }, [
                m('label', { class: label }, 'Name'),
                m('input', {
                  class: input,
                  type: 'text',
                  value: name,
                  oninput: (e) => { name = e.target.value },
                  required: true,
                }),
              ])
            : null,

          m('div', { class: fieldGroup }, [
            m('label', { class: label }, 'Email'),
            m('input', {
              class: input,
              type: 'email',
              value: email,
              oninput: (e) => { email = e.target.value },
              required: true,
            }),
          ]),

          !isForgotPassword
            ? m('div', { class: fieldGroup }, [
                m('label', { class: label }, 'Password'),
                m('input', {
                  class: input,
                  type: 'password',
                  value: password,
                  oninput: (e) => { password = e.target.value },
                  required: true,
                  minlength: 8,
                }),
              ])
            : null,

          isSignup && !isForgotPassword
            ? m('div', { class: fieldGroup }, [
                m('label', { class: label }, 'Invite code'),
                m('input', {
                  class: input,
                  type: 'text',
                  value: inviteCode,
                  oninput: (e) => { inviteCode = e.target.value },
                  placeholder: 'Required if registration is closed',
                }),
              ])
            : null,

          !resetSent
            ? m('button', {
                class: `${btnPrimary} ${css`width: 100%; justify-content: center;`}`,
                type: 'submit',
              }, isForgotPassword ? 'Send reset link'
                : isSignup ? 'Create account'
                : 'Sign in')
            : null,

          m('div', { class: switchLink }, [
            isForgotPassword
              ? m('a', {
                  onclick: () => { isForgotPassword = false; resetSent = false; authModel.clearError() },
                }, 'Back to sign in')
              : isSignup
                ? ['Already have an account? ', m('a', {
                    onclick: () => { isSignup = false; authModel.clearError() },
                  }, 'Sign in')]
                : [
                    m('a', {
                      onclick: () => { isForgotPassword = true; authModel.clearError() },
                    }, 'Forgot password?'),
                    m('span', ' · '),
                    m('a', {
                      onclick: () => { isSignup = true; authModel.clearError() },
                    }, 'Create account'),
                  ],
          ]),
        ]),
      ])
    },
  }
}
